import { Link } from 'react-router-dom';
import { StatusBadge } from '@/components/StatusBadge.js';
import { getOpenBlockers } from '@/lib/issue-links.js';
import type { JiraIssueLink } from '@shared/types.js';

/** Says at the top of an issue that it cannot move yet, and what it is waiting for. */
export function BlockedNotice({ links }: { links: JiraIssueLink[] | undefined }) {
  const blockers = getOpenBlockers(links);
  if (blockers.length === 0) return null;

  return (
    <div className="mb-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3" role="status" aria-label="Blocked">
      <p className="flex items-center gap-1.5 text-sm font-semibold text-red-800">
        <svg viewBox="0 0 16 16" className="h-4 w-4" aria-hidden="true">
          <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeWidth={1.8} />
          <path d="M3.8 12.2l8.4-8.4" stroke="currentColor" strokeWidth={1.8} />
        </svg>
        Blocked by {blockers.length === 1 ? '1 work item' : `${blockers.length} work items`} not yet done
      </p>
      <ul className="mt-1.5 space-y-1">
        {blockers.map((b) => (
          <li key={b.id} className="flex items-center gap-2 text-sm">
            <Link to={`/issues/${b.issue.key}`} className="shrink-0 font-medium text-blue-700 hover:underline">{b.issue.key}</Link>
            <Link to={`/issues/${b.issue.key}`} className="min-w-0 flex-1 truncate text-gray-800 hover:text-blue-700" title={b.issue.summary}>{b.issue.summary}</Link>
            <StatusBadge status={b.issue.status} />
          </li>
        ))}
      </ul>
    </div>
  );
}
